import { useSelector } from "react-redux";
import { StoreProptypes } from "../../PropTypes/StoreProptypes";
import { useTranslation } from "react-i18next";
import { websiteListPropType } from "../../PropTypes/WebsitePropTypes";
import parseISODate from "../../Helpers/parseISODate";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import IsVerified from '../../Assets/img/verified.png';
import InVerified from '../../Assets/img/Inactive.png';

interface PropTypes {
    item: websiteListPropType, // website object
    srno: number, // serial number
    handleSetCurrentWebsite: Function // function to set current website
    handleEditModelName: Function // function to set current website
    handleDeleteDomain:Function
}

// component to render website list with trial plan
const TrialPlanWebsiteListTableCellBlock = (props: PropTypes) => {
    // PropTypes
    const { item, srno, handleSetCurrentWebsite, handleEditModelName, handleDeleteDomain } = props;

    // Redux Data
    const { user, currentWebsitePlanStatus } = useSelector((store: StoreProptypes) => store);

    // Functions
    const { t } = useTranslation();

    return (
        <div className="aioa_dashboard-table-tr">

            <div className="aioa_dashboard-table-td tcw-100 aioa_dashboard-table-cell-sidegap">
                <div className='aioa_dashboard-table-td-cell-title d-none' aria-hidden="true">{t("Sr No")}</div>
                <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Sr No").toString()}>{srno}</div>
            </div>

            <div className="aioa_dashboard-table-td tcw-350 aioa_dashboard-table-cell-sidegap">
                <div className='aioa_dashboard-table-td-cell-title d-none' aria-hidden="true">{t("Domain")}</div>
                <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Domain").toString()}>
                    <div className="domain-name">
                        {!item.is_free_widget && (
                            <>
                                {item.is_verified === 1 ? (
                                    <>
                                        <OverlayTrigger
                                            placement="right"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={
                                                <Tooltip data-bs-html="true" id="button-tooltip">
                                                    <span className="text-start">{t("Widget is active")}</span>
                                                </Tooltip>
                                            }
                                        >
                                            <div className={`domain-verify-icon`}>
                                                <img src={IsVerified} alt='' />
                                            </div>
                                        </OverlayTrigger>
                                    </>
                                ) : (
                                    <>
                                        {item.widget_last_use_date ? (
                                            <>
                                                <OverlayTrigger
                                                    placement="right"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={
                                                        <Tooltip data-bs-html="true" id="button-tooltip">
                                                            <span className="text-start">{t(`Widget was lastly used on ${parseISODate(item.widget_last_use_date)}`)}</span>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div className={`domain-verify-icon`}>
                                                        <img src={InVerified} alt='' />
                                                    </div>
                                                </OverlayTrigger>
                                            </>
                                        ) : (
                                            <>
                                                <OverlayTrigger
                                                    placement="right"
                                                    delay={{ show: 250, hide: 400 }}
                                                    overlay={
                                                        <Tooltip data-bs-html="true" id="button-tooltip">
                                                            <span className="text-start">{t("Widget activation is pending.")}</span>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <div className={`domain-verify-icon`}>
                                                        <img src={InVerified} alt='' />
                                                    </div>
                                                </OverlayTrigger>
                                            </>
                                        )}
                                    </>
                                )}
                            </>
                        )}
                        {item.domain}
                         {/* &nbsp;
                            {((!currentWebsitePlanStatus.isExpired) || (currentWebsitePlanStatus.planExpiredData !== null || currentWebsitePlanStatus.planName !== null)) && (
                                <>
                                    <i className="material-symbols-outlined" aria-hidden="true" style={{ cursor: 'pointer' }} onClick={(e) => handleEditModelName(item.id)}>edit</i>
                                </>
                            )} */}
                        
                    </div>
                </div>
            </div>

            {/* <div className="aioa_dashboard-table-td tcw-150 text-center aioa_dashboard-table-cell-sidegap">
                <div className='aioa_dashboard-table-td-cell-title d-none' aria-hidden="true">{t("Plan")}</div>
                <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Plan").toString()}>{item.current_package_only[0].name}</div>
            </div> */}
             <div className="aioa_dashboard-table-td tcw-150 text-center aioa_dashboard-table-cell-sidegap">
            <div className='aioa_dashboard-table-td-cell-title d-none' aria-hidden="true">{t("Plan")}</div>
                <div
                    className='aioa_dashboard-table-td-cell-value'
                    aria-label={t("Plan").toString()}
                >
                    
                    {item.current_package_only[0].name}
       {item.current_package_only[0]?.platforms === "free-license" ? (<></>) : (<>
                    {(item?.current_package_only[0].subscr_interval === "M" ? (
                        <><br />({t("Monthly Plan Type")})</>
                    ) : (
                        <><br />({t("Annually Plan Type")})</>
                    ))}
    </>)}
                </div>

        </div>

            <div className="aioa_dashboard-table-td tcw-150 text-center aioa_dashboard-table-cell-sidegap">
                <div className='aioa_dashboard-table-td-cell-title d-none' aria-hidden="true">{t("Status")}</div>
                <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Status").toString()}><strong className="text-warning">{t('Trial Plan Label')}</strong></div>
            </div>

            <div className="aioa_dashboard-table-td tcw-150 text-center aioa_dashboard-table-cell-sidegap">
                <div className='aioa_dashboard-table-td-cell-title d-none' aria-hidden="true">{t("Price(USD)")}</div>
                <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Price(USD)").toString()}>       {item.current_package_only[0]?.platforms === "free-license" ? (<>{t("N/A")}</>) : (<>${item.current_package_only[0].final_price}</>)
                }</div>
            </div>

            <div className="aioa_dashboard-table-td tcw-150 text-center aioa_dashboard-table-cell-sidegap">
                <div className='aioa_dashboard-table-td-cell-title d-none' aria-hidden="true">{t("Renew Date")}</div>
                       {item.current_package_only[0]?.platforms === "free-license" ? (<>{t("N/A")}</>) : (<>
                <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Renew Date").toString()}>{parseISODate(item.current_package_only[0].end_date)}</div>
                </>)}
            </div>
{(user?.parent_id === 1 || user?.parent_id === 0) && (
            <div className="aioa_dashboard-table-td tcw-200 text-center aioa_dashboard-table-cell-sidegap">
                <div className='aioa_dashboard-table-td-cell-title d-none' aria-hidden="true">{t("Manage Plan")}</div>
                <div className='aioa_dashboard-table-td-cell-value' aria-label={t("Manage Plan").toString()}>
                    <Button variant="link" onClick={() => handleSetCurrentWebsite(item.id)}>{t('view report btn label')}</Button>
                </div>
            </div>
)}
       {item.current_package_only[0]?.platforms === "free-license" ? (<>{t("N/A")}</>) : (<>
{(user?.parent_id === 1 || user?.parent_id === 0) && (

            <div className="aioa_dashboard-table-td tcw-50 text-center aioa_dashboard-table-cell-sidegap justify-content-center">
                {((!currentWebsitePlanStatus.isExpired) || (currentWebsitePlanStatus.planExpiredData !== null || currentWebsitePlanStatus.planName !== null)) && (
                    <>
                        <i className="material-symbols-outlined" aria-hidden="true" style={{ cursor: 'pointer' }} onClick={(e) => handleEditModelName(item.id)}>edit</i>
                    </>
                )}

                {user && user.department !== 1 && user.is_multiple_domain === 2 ? (
                    <>
                            
                            {item.is_show_price !== 0  ? 
                            <i className={`material-symbols-outlined`} aria-hidden="true" style={{ cursor: 'pointer' }} onClick={() => handleDeleteDomain(item.id)}>delete</i>
                            : <div className="aioa_dashboard-table-td tcw-50 text-center aioa_dashboard-table-cell-sidegap"></div>}
                    </>
                ) : <></>}
            </div>
)}
</>)}
        </div>
    )
}

export default TrialPlanWebsiteListTableCellBlock;